import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import { cx } from '@emotion/css';
import { Org } from '@/types/flyer';
import styles from './ProvidedByCommunity.styles';
import { BodyMedium, BodySmallMidEmphasis, TitleSmallEmphasized } from '@/design-system';
import colors from '@/theme/colors';
import { FollowButton } from '@/pages/OrgProfile/components/FollowButton/FollowButton';

interface Props {
  org: Org;
  goToOrgProfile: () => void;
}

export const ProvidedByCommunity: React.FC<Props> = ({ org, goToOrgProfile }) => (
  <div className={styles.container}>
    <TitleSmallEmphasized>Provided By</TitleSmallEmphasized>
    <div className={styles.orgNameContainer}>
      <div className={styles.orgNameWrapper}>
        <div className={styles.icon}>
          <ApartmentOutlinedIcon sx={{ fontSize: 18 }} />
        </div>
        <div data-testid="orgProfileContainer">
          <TitleSmallEmphasized
            className={styles.orgName}
            color={colors.jungle}
            data-testid="orgName"
            onClick={() => goToOrgProfile()}
          >
            {org.name}
          </TitleSmallEmphasized>
          <div>
            <BodySmallMidEmphasis color={colors.slate}>Community Organization</BodySmallMidEmphasis>
          </div>
        </div>
      </div>
      <FollowButton />
    </div>
  
    {org.description && (
      <div className={styles.disclaimer}>
        <BodyMedium color={colors.midnight} data-testid="orgDescription">
          {org.description}
          Develop and nurture leadership traits, sportsmanship, and team spirit in youth via community and sport programs.
        </BodyMedium>
      </div>
    )}
  </div>
);
